import { HttpInterceptorFn } from '@angular/common/http';
import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@infra-env/environment';

export const baseUrlInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  if (!req.url.startsWith('http://') && !req.url.startsWith('https://')) {
    const apiUrl = environment.apiUrl;
    const url = req.url.startsWith('/') ? req.url : `/${req.url}`;
    
    const clonedRequest = req.clone({
      url: `${apiUrl}${url}`,
    });
    
    return next(clonedRequest);
  }
  return next(req);
};
